import Dialog from "../utils/Dialog";

class AnnouncementBanner {
    constructor(element) {
        this.el = element;
        this.dialog = new Dialog(element, {
            backdropClose: false,
            name: "announcement-banner",
        });

        this.announcementId = element.id;
        this.init();
    }

    init() {
        if (this.shouldShowAnnouncement()) {
            setTimeout(() => {
                this.dialog.open();
            }, 3000);
        }

        this.el.addEventListener("close", () => {
            this.onClose();
        });

        this.el.addEventListener("click", (event) => {
            this.saveInteraction();
        });
    }

    shouldShowAnnouncement() {
        const closedAnnouncementId = localStorage.getItem(
            "closedAnnouncementId",
        );

        return closedAnnouncementId !== this.announcementId;
    }

    saveInteraction() {
        localStorage.setItem("closedAnnouncementId", this.announcementId);
    }

    onClose() {
        this.el.remove();

        this.saveInteraction();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const dialogElements = document.querySelectorAll(
        "[data-announcement-banner]",
    );

    dialogElements.forEach((element) => {
        new AnnouncementBanner(element);
    });
});
